"use client";

import { useEffect } from "react";

/**
 * Writes `data-scrolled="true|false"` on the document element whenever the
 * page is scrolled past a small threshold. Other components style themselves
 * off this attribute (e.g. the site header collapses its second row, sticky
 * sub-navs reduce padding) without each needing its own scroll listener.
 */
export function ScrollState() {
  useEffect(() => {
    const update = () => {
      const scrolled = window.scrollY > 4;
      const next = scrolled ? "true" : "false";
      if (document.documentElement.dataset.scrolled !== next) {
        document.documentElement.dataset.scrolled = next;
      }
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);
  return null;
}
